// FATF and EU High-Risk country data for seed purposes
// Format: [{ code: 'XX', value: true }] — only listed countries included (unlisted countries get value: false via fallback)

// FATF Grey List + Black List countries (alpha2 codes)
export const fatfListedCountries = [
  'AF', // Afghanistan
  'AL', // Albania
  'BB', // Barbados
  'BF', // Burkina Faso
  'CM', // Cameroon
  'KY', // Cayman Islands
  'CG', // Congo
  'CD', // Congo (DRC)
  'CI', // Côte d'Ivoire
  'ET', // Ethiopia
  'HT', // Haiti
  'IR', // Iran (Black List)
  'JM', // Jamaica
  'JO', // Jordan
  'KE', // Kenya
  'ML', // Mali
  'MA', // Morocco
  'MZ', // Mozambique
  'MM', // Myanmar (Black List)
  'NG', // Nigeria
  'KP', // North Korea (Black List)
  'PA', // Panama
  'PH', // Philippines
  'SN', // Senegal
  'ZA', // South Africa
  'SS', // South Sudan
  'SY', // Syria
  'TZ', // Tanzania
  'TT', // Trinidad and Tobago
  'UG', // Uganda
  'AE', // United Arab Emirates
  'VN', // Viet Nam
  'YE', // Yemen
];

// EU High-Risk Third Countries (per EU Delegated Regulation)
export const euHighRiskCountries = [
  'AF', // Afghanistan
  'BB', // Barbados
  'BF', // Burkina Faso
  'CM', // Cameroon
  'KY', // Cayman Islands
  'CG', // Congo
  'CI', // Côte d'Ivoire
  'ET', // Ethiopia
  'GH', // Ghana
  'HT', // Haiti
  'IR', // Iran
  'JM', // Jamaica
  'JO', // Jordan
  'ML', // Mali
  'MA', // Morocco
  'MZ', // Mozambique
  'MM', // Myanmar
  'NG', // Nigeria
  'KP', // North Korea
  'PA', // Panama
  'PH', // Philippines
  'SN', // Senegal
  'ZA', // South Africa
  'SS', // South Sudan
  'SY', // Syria
  'TZ', // Tanzania
  'TT', // Trinidad and Tobago
  'UG', // Uganda
  'AE', // United Arab Emirates
  'VN', // Viet Nam
  'YE', // Yemen
];

// Build seed data arrays in the format expected by GeoRiskService.getCountryData()
// We store only listed=true entries; unlisted countries default to false via absence
export const fatfIndexSeedData = fatfListedCountries.map(code => ({ code, value: true }));
export const euHighRiskIndexSeedData = euHighRiskCountries.map(code => ({ code, value: true }));
